// extracted by mini-css-extract-plugin
export default {"uw":"UploadWrapper_uw__RT5XJ"};